import React from 'react';
import useGeneralStyles from 'apps/Pdf/styles/general';
import Grid from '@material-ui/core/Grid';
import { Currency } from 'enums';

interface Props {
  hedging?: boolean;
  rebalancing: boolean;
  rebalancingTimeTest: boolean;
  currency: Currency;
}

const HedgingRebalancing = (props: Props) => {
  const styles = useGeneralStyles();
  const { hedging, rebalancing, rebalancingTimeTest } = props;
  const activeLabel = `colorDark ${styles.bold}`;
  const active = `${styles.mediumText} colorDark`;
  const inactive = `${styles.mediumText} ${styles.gray}`;
  const showHedging = props.currency === Currency.CZK && props.hedging !== undefined;

  return (
    <>
      {showHedging && (
        <Grid item xs={6} className={`${hedging ? activeLabel : ''} ${styles.right}`}>
          <span className={hedging ? active : inactive}>{hedging ? <>&#9745;</> : <>&#9744;</>}</span> Měnové zajištění
          &nbsp;&nbsp;
        </Grid>
      )}
      <Grid item xs={showHedging ? 6 : 12} className={`${rebalancing ? activeLabel : ''} ${showHedging ? styles.left : styles.center}`}>
        &nbsp;&nbsp;
        <span className={rebalancing ? active : inactive}>{rebalancing ? <>&#9745;</> : <>&#9744;</>}</span> Rebalancing
        {rebalancing && <>{rebalancingTimeTest ? ' (daňově optimální)' : ' (striktní)' }</>}
      </Grid>
    </>
  );
};

export default HedgingRebalancing;
